/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PayerSearchOptionsPayerRequiredFieldsInner
 */
export interface PayerSearchOptionsPayerRequiredFieldsInner {
    /**
     * 
     * @type {boolean}
     * @memberof PayerSearchOptionsPayerRequiredFieldsInner
     */
    is_active: boolean;
    /**
     * 
     * @type {string}
     * @memberof PayerSearchOptionsPayerRequiredFieldsInner
     */
    prompt: string;
    /**
     * 
     * @type {number}
     * @memberof PayerSearchOptionsPayerRequiredFieldsInner
     */
    payer_required_field_type_id: number;
    /**
     * 
     * @type {number}
     * @memberof PayerSearchOptionsPayerRequiredFieldsInner
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof PayerSearchOptionsPayerRequiredFieldsInner
     */
    alt_param_element_name: string;
}

/**
 * Check if a given object implements the PayerSearchOptionsPayerRequiredFieldsInner interface.
 */
export function instanceOfPayerSearchOptionsPayerRequiredFieldsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "is_active" in value;
    isInstance = isInstance && "prompt" in value;
    isInstance = isInstance && "payer_required_field_type_id" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "alt_param_element_name" in value;

    return isInstance;
}

export function PayerSearchOptionsPayerRequiredFieldsInnerFromJSON(json: any): PayerSearchOptionsPayerRequiredFieldsInner {
    return PayerSearchOptionsPayerRequiredFieldsInnerFromJSONTyped(json, false);
}

export function PayerSearchOptionsPayerRequiredFieldsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PayerSearchOptionsPayerRequiredFieldsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'is_active': json['is_active'],
        'prompt': json['prompt'],
        'payer_required_field_type_id': json['payer_required_field_type_id'],
        'id': json['id'],
        'alt_param_element_name': json['alt_param_element_name'],
    };
}

export function PayerSearchOptionsPayerRequiredFieldsInnerToJSON(value?: PayerSearchOptionsPayerRequiredFieldsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'is_active': value.is_active,
        'prompt': value.prompt,
        'payer_required_field_type_id': value.payer_required_field_type_id,
        'id': value.id,
        'alt_param_element_name': value.alt_param_element_name,
    };
}

